module.exports = __webpack_public_path__ + "static/media/petite-cat.b0bfc5f4.png";